import { SubmittalJobQualificationRequirement } from 'src/app/recruiting/candidates/submittal/models/submittal-job-qualification-requirement.model';

export const applyJobSpecificMatch = (
    requirement: SubmittalJobQualificationRequirement,
    jobId: number
): SubmittalJobQualificationRequirement => {
    const jobMatch = requirement?.candidateHasMetRequirementByJobId?.find((match) => match.jobId === jobId);
    if (!jobMatch) {
        return requirement;
    }

    return {
        ...requirement,
        candidateHasMetRequirement: jobMatch.hasMetRequirement,
        isRequirementMissing: jobMatch.hasMetRequirement ? false : requirement.isRequirementMissing
    };
};
